import React from 'react';

import './DealStatus.css';

const inviting = <li styleName="arrow">Inviting Investors</li>;
const invited = <li styleName="tick">Investors Invited</li>;

const sharesAllocate = <li styleName="bullet">Allocate Shares</li>;
const sharesAllocating = <li styleName="arrow">Allocating Shares</li>;
const sharesAllocated = <li styleName="tick">Shares Allocated</li>;

const dealClose = <li styleName="bullet">Close Deal</li>;
const dealClosing = <li styleName="arrow">Closing Deal</li>;
const dealClosed = <li styleName="tick">Deal Closed</li>;

const allocating = () => (
  <ul styleName="list">
    {inviting}
    {sharesAllocate}
    {dealClose}
  </ul>
);

const finalizing = () => (
  <ul styleName="list">
    {invited}
    {sharesAllocating}
    {dealClose}
  </ul>
);

const finalized = () => (
  <ul styleName="list">
    {invited}
    {sharesAllocated}
    {dealClosing}
  </ul>
);

const closed = () => (
  <ul styleName="list">
    {invited}
    {sharesAllocated}
    {dealClosed}
  </ul>
);

const DealStatus = ({status}) => (
  {
    allocating,
    finalizing,
    finalized,
    closed,
  }[status]()
);

export default DealStatus;



// WEBPACK FOOTER //
// ./web/components/DealStatus.js